import React from "react";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Link,
} from "@mui/material";
import csImage from "../../images/cs-image.png";
// a

const ShippingInfo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box component="section" sx={{ px: 2 }}>
      {/* Main Title */}
      <Typography
        variant="h3"
        fontWeight={800}
        sx={{
          textAlign: "center",
          color: "var(--secondary-blue)",
          mb: 1,
          fontSize: { xs: "1.6rem", md: "2.5rem" },
        }}
      >
        One Platform. Your Complete Shipping Solution.
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="h4"
        fontWeight={600}
        sx={{
          textAlign: "center",
          color: "text.primary",
          mb: 6,
          fontSize: { xs: "1rem", md: "1.75rem" },
        }}
      >
        Currently In Development *
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        {/* IMAGE: full width on mobile */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            order: { xs: 1, md: 2 },
            mb: { xs: 3, md: 0 },
          }}
        >
          <img
            src={csImage}
            alt="Customer service and shipping solutions"
            style={{
              maxWidth: "100%",
              height: "auto",
              marginRight: isMobile ? 0 : "-10rem",
            }}
          />
        </Box>

        {/* TEXT CONTENT */}
        <Box
          sx={{
            flex: 1,
            order: { xs: 2, md: 1 },
            textAlign: { xs: "center", md: "left" }, // center text on mobile
          }}
        >
          <Typography
            variant="h5"
            fontWeight={700}
            sx={{
              color: "var(--secondary-blue)",
              mb: 2,
              fontSize: { xs: "1.3rem", md: "1.6rem" },
            }}
          >
            Shipping Made Simple
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "text.secondary",
              mb: 3,
              lineHeight: 1.6,
            }}
          >
            {isMobile ? (
              <>
                <strong>Hunting carrier rates</strong> can be slow and costly.
                Our <strong>all-in-one platform</strong> simplifies shipping,
                saves <strong>time</strong> and <strong>money</strong>, and
                keeps operations smooth.
              </>
            ) : (
              <>
                <strong>Hunting down carrier rates on your own</strong> can be
                slow, frustrating, and often leads to paying more than you
                should. Our <strong>all-in-one shipping platform</strong>{" "}
                streamlines every step— from comparing prices to booking and
                tracking—giving your business access to{" "}
                <strong>exclusive discounted rates</strong> in real time. This
                means you save both <strong>time</strong> and{" "}
                <strong>money</strong>
                with every shipment, while keeping operations running smoothly.
                <br />
                <br />
                We work with{" "}
                <strong>top Canadian and global shipping providers</strong> to
                offer flexible solutions for small and mid-sized businesses. Our
                network covers{" "}
                <strong>domestic and cross-border LTL freight</strong>,
                <strong> international courier services</strong>, eCommerce
                integrations, and much more. Whether you’re sending a single
                parcel or managing high-volume freight, you can count on us for{" "}
                <strong>speed</strong>,<strong> reliability</strong>, and{" "}
                <strong>cost efficiency</strong>.
                <br />
                <br />
                With everything in one place, you’ll never need to juggle
                multiple platforms or waste hours chasing quotes again—just ship
                smarter, faster, and with confidence.
              </>
            )}
          </Typography>

          <Button
            component={Link}
            href="https://skymartexpress.com"
            target="_blank"
            variant="contained"
            sx={{
              backgroundColor: "var(--yellow-main)",
              color: "#000",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "var(--yellow-hover)" },
              borderRadius: "8px",
              px: 3,
              py: 1,
              fontSize: "1rem",
              boxShadow: "none",
              mx: { xs: "auto", md: "unset" }, // centers on mobile
              display: "inline-block", // prevents stretching
            }}
          >
            Get Started
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ShippingInfo;
